import { render, staticRenderFns } from "./productionDemandPage.vue?vue&type=template&id=0efedc8f&scoped=true"
import script from "./productionDemandPage.vue?vue&type=script&lang=js"
export * from "./productionDemandPage.vue?vue&type=script&lang=js"
import style0 from "./productionDemandPage.vue?vue&type=style&index=0&id=0efedc8f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efedc8f",
  null
  
)

export default component.exports